import { Pagination } from 'antd';
import React, { memo } from 'react';
import '../../styles/paginator.scss';
import { ArrowIcon } from '../mini/icons';

const Paginator = (props) => {
  function itemRender(current, type, originalElement) {
    if (type === 'prev') {
      return <ArrowIcon direction="left" active={props.currentPage > 1}/>
    } else if (type === 'next') {
      const s = props.size || 10;
      return <ArrowIcon active={props.count > s && (Math.ceil(props.count / (s * props.currentPage)) > 1)}/>
    }
    return originalElement;
  }
  return (
    <div className="paginator mt-12">
      {props.count > (props.size || 10) && <Pagination
        className='pagination'
        current={props.currentPage}
        pageSize={props.size || 10}
        showSizeChanger={false}
        onChange={props.pageChange}
        total={props.count}
        itemRender={itemRender}
      />}
    </div>
  )
}

export default memo(Paginator)
